 function padInt(int) {
   return int < 10 ? '0'+int : int;
 }

function utcDateString(d) {
  // TODO: use a timezone aware date-fns package for this
  return `${d.getUTCFullYear()}-${padInt(d.getUTCMonth()+1)}-${padInt(d.getUTCDate())}, ${padInt(d.getUTCHours())}:${padInt(d.getUTCMinutes())} UTC`;
}

function luxonToUtc(dateTime) {
  if (!dateTime) {
    return null;
  }
  return dateTime
    .setZone('UTC')
    .toFormat("y-LL-dd'T'HH:mm:'00Z'");
}

/**
 * Take a luxon object in UTC, adjust the timezone and time so the local time stays the same, and return the new time in UTC.
 *
 * Example: 09:00 America/Chicago (-0600) to 09:00 America/Detroit (-0500) will accept 15:00 UTC and return 14:00 UTC.
 */
function luxonTimezoneShift(dateTime, currentTimezone, newTimezone) {
  if (!dateTime || !currentTimezone || !newTimezone) {
    return dateTime;
  }

  return dateTime
    .setZone(currentTimezone)
    .setZone(newTimezone, {keepLocalTime: true})
    .setZone('UTC');
}

const isMac = window.navigator.platform === 'MacIntel';

function isCtrlOrCmd(e) {
  return (isMac && e.metaKey) || (!isMac && e.ctrlKey);
}

let copyBox;
function copyText(text) {
  if (!copyBox) {
    copyBox = document.createElement('textarea');
    copyBox.classList.add('copy-placeholder');
    document.body.appendChild(copyBox);
  }
  copyBox.setAttribute('readonly', false);
  copyBox.value = text;
  copyBox.select();
  document.execCommand('copy');
  copyBox.setAttribute('readonly', true);
}

/**
 * Given a jQuery element $icon with class .fa-link, animate a change
 * to .fa-check and back again.
 */
function animateCopyIcon($icon) {
    $icon.removeClass('fa-link')
      .addClass('fa-check')
      .addClass('text-success');

    setTimeout(function() {
      $icon.addClass('fa-link')
        .removeClass('fa-check')
        .removeClass('text-success');
    }, 2000);
}

export {isCtrlOrCmd, copyText, utcDateString, luxonToUtc, luxonTimezoneShift, animateCopyIcon}



// WEBPACK FOOTER //
// ./assets/js/utils.js